module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-super-container",
    attrs: {
      "id": "options-tabs-super-container"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLeftShadow),
      expression: "showLeftShadow"
    }],
    staticClass: "box-shadow-container left box-shadow-container-options-left"
  }, [_c('img', {
    staticClass: "chevron",
    attrs: {
      "src": '/img/icons/left-chevron-' + _vm.mode + '.svg',
      "alt": "Scroll left"
    }
  })]), _c('div', {
    staticClass: "tabs-container",
    style: ('max-width: ' + _vm.tabsContainerMaxWidth + 'px'),
    attrs: {
      "id": "option-tabs-container"
    }
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [_vm._l((_vm.listOfSystemTabs), function(item) {
    return _c('li', {
      class: {
        'active': item.code === _vm.selectedTab.code
      },
      on: {
        "click": function($event) {
          return _vm.select(item)
        }
      }
    }, [_c('div', {
      staticClass: "flex aic"
    }, [_c('a', [_c('span', [_vm._v(" " + _vm._s(item.name))]), (_vm.newsCount > 0) ? _c('span', {
      staticClass: "tag-new-count"
    }, [_vm._v(_vm._s(_vm.newsCount))]) : _vm._e()])])])
  }), _vm._m(0), _vm._l((_vm.listOfTabs), function(item) {
    return _c('li', {
      class: {
        'active': item.code === _vm.selectedTab.code
      },
      on: {
        "click": function($event) {
          return _vm.select(item)
        }
      }
    }, [_c('div', {
      staticClass: "flex aic"
    }, [_c('a', [_c('span', [_vm._v(" " + _vm._s(item.name)), (item.animated) ? _c('span', {
      staticClass: "animated-circle hint--right",
      attrs: {
        "aria-label": "Updating in real-time"
      }
    }) : _vm._e()]), (item.code === 'referrals' && _vm.hasCustomCode) ? _c('span', {
      staticClass: "hint--right",
      attrs: {
        "aria-label": "Custom Referral code enabled!"
      }
    }, [_vm._v(" 🚀")]) : _vm._e()])])])
  })], 2)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRightShadow),
      expression: "showRightShadow"
    }],
    staticClass: "box-shadow-container right box-shadow-container-options-right"
  }, [_c('img', {
    staticClass: "chevron",
    attrs: {
      "src": '/img/icons/right-chevron-' + _vm.mode + '.svg',
      "alt": "Scroll right"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "separator-li"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cbc05f6","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_tab_option_select.vue
// module id = 378
// module chunks = 1